import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "HomeSchool Hub — Florida Homeschool Teacher Platform";
const DEFAULT_DESCRIPTION =
  "The all-in-one platform for Florida homeschool teachers. Schedule lessons, track WRAT-5 assessments, generate compliant Portfolio/Evaluation PDFs, and stay on top of every FES-EO, FES-UA & PEP scholarship.";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://www.flhomeschoolhub.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * SEO/meta wrapper. Sets <title>, description, canonical, OG, Twitter card,
 * and any JSON-LD schema payloads for a page.
 */
export function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
  jsonLd = null,
  type = "website",
}) {
  const fullTitle = title ? `${title} · HomeSchool Hub` : DEFAULT_TITLE;
  const canonical = `${SITE_URL}${path}`;
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content="HomeSchool Hub" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content="HomeSchool Hub — Florida homeschool, made simple." />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export const siteUrl = SITE_URL;
